module.exports = __webpack_public_path__ + "static/img/nav13.7f5d7b9f.svg";